// src/components/Dashboard/DashboardView.jsx
// Container for the Dashboard mode - Routes to appropriate dashboard based on role

import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { 
  PERSONAS,
  getEmptyStateMessage
} from '../../utils/personaDetection';
import { ClubOwnerDashboard } from './ClubOwnerDashboard';
import { CoachDashboard } from './CoachDashboard';
import { PlayerDashboard } from './PlayerDashboard';
import styles from './DashboardView.module.css';

const DashboardView = ({
  user,
  userProfile,
  userClubs,
  refreshUserClubs,
  onViewClub,
  onEditClub,
  onJoinClub,
  onExploreClick,
  // Mode toggle props
  activeMode,
  onModeChange
}) => {
  // Get dashboard role from user profile (set during onboarding)
  // Falls back to 'player' if not set
  const dashboardRole = userProfile?.dashboardRole || 'player';
  
  const isOwner = dashboardRole === 'club_owner';
  const isCoach = dashboardRole === 'coach';
  const isParent = dashboardRole === 'parent';
  const isPlayer = dashboardRole === 'player' || isParent;
  
  // Check if user is a new user (no clubs)
  const isNewUser = !userClubs || userClubs.length === 0;

  // Empty state for no clubs (only for players - owners/coaches might want to create clubs)
  if (isNewUser && isPlayer) {
    const emptyState = getEmptyStateMessage(PERSONAS.NEW_USER, 'clubs');
    return (
      <div className={styles.dashboardView}>
        <div className={styles.welcomeState}>
          <div className={styles.welcomeIcon}>{emptyState.icon}</div>
          <h2>{emptyState.title}</h2>
          <p>{emptyState.message}</p>
          <button 
            className={styles.exploreButton}
            onClick={onExploreClick}
          >
            {emptyState.actionLabel} <FaArrowRight />
          </button>
        </div>
      </div>
    );
  }

  // Club Owner Dashboard - for users who selected "I'm a Club Owner"
  if (isOwner) {
    return (
      <ClubOwnerDashboard
        userClubs={userClubs}
        activeMode={activeMode}
        onModeChange={onModeChange}
        onExploreClick={onExploreClick}
      />
    );
  }

  // Coach Dashboard - for users who selected "I'm a Coach"
  if (isCoach) {
    return (
      <CoachDashboard
        userClubs={userClubs}
        userProfile={userProfile}
        activeMode={activeMode}
        onModeChange={onModeChange}
        onExploreClick={onExploreClick}
      />
    );
  }

  // Player Dashboard - for users who selected "I'm a Player" or default
  return (
    <PlayerDashboard
      userClubs={userClubs}
      activeMode={activeMode}
      onModeChange={onModeChange}
      onExploreClick={onExploreClick}
    />
  );
};

export default DashboardView;
